import { PHOTO_FILES_LIMIT_SIZE } from './const';
import type { Photo } from './types';

const b64StringSize = (b64data: string): number => {
    const base64WithoutPrefix = b64data.split(',')[1] || b64data;
    const base64Length = base64WithoutPrefix.length;
    let padding = 0;
    if (base64WithoutPrefix.endsWith('==')) {
        padding = 2;
    } else if (base64WithoutPrefix.endsWith('=')) {
        padding = 1;
    }
    const fileSizeInBytes = (base64Length * 3) / 4 - padding;

    return fileSizeInBytes;
};

export const validateFilesSize = (files: Photo[]): boolean => {
    let isFilesSizeValid = true;
    files.forEach((file) => {
        if (file.b64data) {
            const fileB64DataSize = b64StringSize(file.b64data);
            if (fileB64DataSize > PHOTO_FILES_LIMIT_SIZE) {
                isFilesSizeValid = false;
            }
        }
    });

    return isFilesSizeValid;
};
